import React, { useState } from 'react'
import { Box, IconButton, Menu, MenuItem, Button } from '@mui/material'
import { useSelector } from 'react-redux'
import CircleIcon from '@mui/icons-material/Circle';
import { useNavigate } from 'react-router-dom';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { useDispatch } from "react-redux"
import { logoutUser } from '../../redux/slice/user';

const options = [
  'Logout',
  '다른거',
];

const ITEM_HEIGHT = 48;


const AppHeader = (props:any) => {

  // const setSwitchPage = props.setSwitchPage;

  const dispatch = useDispatch();
  const nav = useNavigate();

  const state_data = useSelector((state:any) => state);

  // console.log('앱 해더 state' , state_data)

  const auth = useSelector((state:any) => state.userInfo.data);
  // console.log('App 해더 userInfo',auth)
  let role_admin = auth.user.roles.some((obj:any) => ['ADMIN','MANAGER','WORKER_DIALOG','WORKER_SOUND','WORKER_NOISE'].includes(obj.role))

  let role_vie = auth.user.roles.some((obj:any) => ['VIE','VIE_PRC','VIE_MANAGER'].includes(obj.role))

  let role_tza = auth.user.roles.some((obj:any) => ['TZA','TZA_ISP'].includes(obj.role))
  let role_khm = auth.user.roles.some((obj:any) => ['KHM','KHM_ISP','KHM_TRS'].includes(obj.role))

  let role_eval = auth.user.roles.some((obj:any) => ['EVAL','EVAL_PRC','EVLT_PRC'].includes(obj.role))
  let role_ssb = auth.user.roles.some((obj:any) => ['SSB','SSB_PRC'].includes(obj.role))
  // let role_admin = auth.user.roles.some((obj:any) => ['MANAGER','WORKER_DIALOG','WORKER_SOUND','WORKER_NOISE'].includes(obj.role))

  // console.log('role_admin',role_admin)

  const logout = () => {
    dispatch(logoutUser())
  }
  // var nav = useNavigate();
  // const auth = useSelector((state:any) => state.userInfo.data);
  // console.log('Header page userInfo',auth)

  // const dispatch = useDispatch();

  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const open = Boolean(anchorEl);

  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  //   // console.log('event.currentTarget',event.currentTarget)
  // };
  // const handleClose = (e:any) => {
  //   console.log('anchorEl',e.target.innerText, anchorEl)
    
  //   setAnchorEl(null);
  //   if(e.target.innerText === 'Logout')
  //     dispatch(logoutUser())
  // };
  
  


  return (
    <Box sx={{backgroundColor: "#fff", color: "#000", fontWeight : 500, height:"80px", padding:"16px 16px 0px 16px"}}>
      {/* <Box sx={{display: "flex", marginLeft:2, cursor: "pointer"}} onClick={()=> nav('/insight/main')}> */}
      <Box sx={{display: "flex", marginLeft:"10px"}}>
        <Box sx={{display: "flex"}}>
          <img style={{objectFit: "cover", alignSelf: "center", cursor:"pointer"}} onClick={()=> {nav('/');}} src={process.env.PUBLIC_URL + '/img/insightinfo_logo.png'} />
        </Box>
        {/* {route_page ? 
        <Box display="flex">
          <Box sx={{fontSize: "xx-large", alignSelf: "center", color: "#3e36a5", fontWeight : 700, le`tterSpacing : "-1px"}}>INSIGHT</Box>
          <Box sx={{fontSize: "x-large", alignSelf: "center", color: "#646464", fontWeight : 700, letterSpacing : "-1px", margin: "4px 12px 0 12px"}}>관리자</Box>
        </Box>
        :
        <Box sx={{fontSize: "xx-large", alignSelf: "center", color: "#3e36a5", fontWeight : 700, letterSpacing : "-1px"}}>INSIGHT</Box>} */}
        {auth.login ? 
        <React.Fragment>
          <Box sx={{display:"flex" , margin:"auto"}}>
            <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px"}}>My</Box>
            <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px", letterSpacing: "-2px", cursor:"pointer"}} onClick={()=>nav("/upload")}>데이터 제출</Box>
            {role_ssb ? <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px", letterSpacing: "-2px", cursor:"pointer"}} onClick={()=>nav("/ssb-worker")}>성능평가</Box> : ""}
            {role_eval ? <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px", letterSpacing: "-2px", cursor:"pointer"}} onClick={()=>nav("/eval-worker")}>성능평가</Box> : ""}
            {role_tza ? <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px", letterSpacing: "-2px", cursor:"pointer"}} onClick={()=>nav("/tza-worker")}>TZA</Box> : ""}
            {role_khm ? <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px", letterSpacing: "-2px", cursor:"pointer"}} onClick={()=>nav("/khm-worker")}>KHM</Box> : ""}
            {role_vie ? <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px", letterSpacing: "-2px", cursor:"pointer"}} onClick={()=>nav("/vie-worker")}>VIE</Box> : ""}
            {role_admin ? <Box sx={{fontSize: "26px", fontWeight: 800, color: "#797979", marginRight: "140px", letterSpacing: "-2px", cursor:"pointer"}} onClick={()=>nav("/admin")}>관리자</Box> : ""}

            
          </Box>
          {/* <Box sx ={{marginTop: "1%", marginRight: "5%"}}><Button variant="contained" sx={{backgroundColor:"#3e36a5"}} onClick={logout}>로그아웃</Button></Box> */}
          {/* <Box sx={{fontSize: "24px", fontWeight: 700, color: "#797979", marginRight: "140px"}} onClick={logout}>로그아웃</Box> */}
        </React.Fragment>
         : "" }
      </Box>
      <Box sx={{display:"flex", marginTop: "-16px"}}>
      {/* <Box sx ={{letterSpacing: "4px", marginLeft: "40px", fontSize: "small",fontWeight: 700,textShadow: "0 0 black",color: "#6b6969"}}>인 사 이 트 정 보</Box> */}
        {auth.login ? 
          <Box sx ={{marginLeft: "auto", marginRight: "3%", fontSize: "small",fontWeight: 800,textShadow: "0 0 black",color: "#6b6969", cursor:"pointer"}} onClick={logout}>로그아웃</Box>
          : 
          <Box sx ={{marginLeft: "auto", marginRight: "3%", fontSize: "small",fontWeight: 800,textShadow: "0 0 black",color: "#6b6969"}}>{<b style={{cursor:"pointer"}} onClick={()=> props.setSwitchPage(false)}>로그인</b>} | <b style={{cursor:"pointer"}} onClick={()=> props.setSwitchPage(true)}>회원가입</b></Box> 
        }
      </Box>
    </Box>
  )
}

export default AppHeader